<template>
  <div class='container'>
    <div class="header">
      <div class="title">SSO统一用户注册</div>
    <div class="tip">
        本网站绝不会以任何形式向第三方透漏你的身份信息（
        <span style="color: red">*</span>为必填项）
      </div>
    </div>
    <div class="con">
      <el-form :model="form" :rules="rules" label-width="100px" ref="ruleForm" >
        <el-form-item label="手机号"   prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
          <el-form-item label="密码"   prop="password">
          <el-input v-model="form.password" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="邮箱" >
          <el-input v-model="form.email"></el-input>
        </el-form-item>
         <el-form-item label="真实姓名" >
          <el-input v-model="form.realName"></el-input>
        </el-form-item>
         <el-form-item label="机构" required>
            <tree-select
        v-if="orgBack"
        @treeAll="orgall"
        :disabled="false"
        style="
          width: 500px;
          display: inline-block;
          vertical-align: bottom;
          font-size: 14px;
        "
        placeholder="请输入机构名称"
        :option="orgOption"
      ></tree-select>
          <!-- <el-input v-model="form.orgId"></el-input> -->
        </el-form-item>
         <el-form-item label="学科" >
          <el-input v-model="form.subject"></el-input>
        </el-form-item>
         <el-form-item style="text-align:right">
    <el-button type="success" @click="submitForm('ruleForm')" >立即创建</el-button>
    <el-button type="success" @click="back" plain>返回</el-button>
  </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
     components: {
    treeSelect:resolve=>require(['./treeSelect'],resolve)
  },
    created(){
       this.$api.structureList1().then((res) => {
      console.log(res)
      if (res.data.code == 200) {
        this.orgBack = true;
        this.orgOption = res.data.data;
      }
    });
    },
    data(){
      return {
      form:{
        phone:'',
        password:'',
        email:'',
        orgId:'',
        realName:'',
        subject:'未分类',
      },
      rules:{
        phone:[{required:true,validator: this.checkphone,trigger: 'blur' }],
         password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
      },
      orgBack:false,
      orgOption:[]
    }},
    methods:{
      back(){
        this.$router.push('ssoLogin')
      },
      checkphone(rule, value, callback){
         if (value === '') {
          callback(new Error('请输入手机号'));
        } else if (/^1[3-9]{2}\d{8}$/.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确手机号!'));
        }
      },
       orgall(x) {
         console.log(x)
      this.form.orgId = x.id;
      // this.form.department = x.name;
    },
         submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
           this.$api.register(this.form).then(res=>{
             console.log(res)
             if(res.data.code==200){
               this.$message({
                 message:'注册成功',
                 type:'success'
               })
                 this.back()
               
             }else{
               this.$message.error(res.data.message)
             }
           })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>

<style scoped lang="scss">
.container{
  width: 800px;
  margin: 70px auto;
  border: 2px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 0 13px 0 #ddd;
}
.header{
  .title{
    font-size: 24px;
    font-weight: bold;
    color: #00ab71;
    margin: 20px 0;
    text-align: center;
  }
  .tip{
    text-align: center;
    margin: 10px 0 20px;
    font-size: 14px;
  }
}
  .con{
    width: 600px;
    margin: 0 auto;
  }
</style>